import {
  CardContainer,
  EntityGroupWorkflowCard,
  EntityGroupWorkflowCardFooter,
  useAssetTypeActions,
  useEnvironment,
} from '@diana/core';
import { routeUrls } from '../../app/Routing/RouteUrls';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { THINGS_GROUP_PAGE_NS } from './i18n';
import { SxProps } from '@mui/system';

export interface IEntityGroupCard {
  entity: any;
  refetch: () => void;
  setProcessing: (status: boolean) => void;
  containerSx?: SxProps;
  peoplePage?: boolean;
  totalCount?: number;
  isFetching?: boolean;
}

export const ThingsGroupCard = (props: IEntityGroupCard) => {
  const { t } = useTranslation(THINGS_GROUP_PAGE_NS);
  const { entity, containerSx, peoplePage, totalCount = 0, isFetching } = props;
  const { imageUrl, flow } = entity;
  const environment = useEnvironment();
  const urlBuilder = peoplePage ? routeUrls.assets : routeUrls.things;
  const { actions } = useAssetTypeActions({
    flow,
    ...props,
    actions: {
      edit: { title: flow?.draftFlowId ? t('actions.continueEditing') : t('actions.edit') },
      manage: { title: t('actions.manage') },
      version: { title: t('actions.showVersion') },
    },
  });

  const iconValue = { imageUrl, icon: flow?.icon?.shape ?? '', color: flow?.icon?.color ?? '' };

  const Footer = useMemo(() => {
    return <EntityGroupWorkflowCardFooter totalItems={totalCount} isFetching={isFetching} />;
  }, [totalCount, isFetching]);

  return (
    <>
      <CardContainer sx={containerSx}>
        <EntityGroupWorkflowCard
          href={urlBuilder.url({ environment, flowOriginId: flow.flowOriginId }, null)}
          actions={actions}
          title={flow.displayName}
          footer={Footer}
          icon={iconValue}
        />
      </CardContainer>
    </>
  );
};
